import { render, staticRenderFns } from "./UserFilters.vue?vue&type=template&id=727dafd1&scoped=true&"
import script from "./UserFilters.vue?vue&type=script&lang=ts&"
export * from "./UserFilters.vue?vue&type=script&lang=ts&"
import style0 from "./UserFilters.vue?vue&type=style&index=0&id=727dafd1&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "727dafd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VIcon,VListItemTitle,VRow})
